import React from 'react';
import radium from 'radium';

import LeoPopup from '../../components/popup/LeoPopup.jsx';
import {ThemeContext} from "../theme/Theme.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class LeoHint extends React.Component {
	static contextType = ThemeContext;
	constructor(props) {
		super(props);

		this.state = {
			showPopup: false,
		};
	}

	togglePopup() {
		this.setState({
			showPopup: !this.state.showPopup,
		});
	}

	render() {
		const style = {
			leoHintContainer: {
				display: 'flex',
				marginTop: '2em',
			},
			leoHintInner: {
				display: 'flex',
			},
			leoHintInfoIcon: {
				marginLeft: '0.7em',
				color: this.context.themeManager.value('leo-hint-icon',
					'color', 'fg-color-icon-highlight'),
				fontSize: this.context.themeManager.value('leo-hint-icon',
					'fontSize', 'font-size-200'),
				cursor: 'pointer',
				lineHeight: '1.1rem',
			},
		};
		return (
			<div style={[style.leoHintContainer, this.props.leoHintContainerStyle]} onClick={() => this.togglePopup()}>
				<div style={style.leoHintInner} dangerouslySetInnerHTML={{ __html: this.props.hintText }} />
				<FontAwesomeIcon
					icon="info-circle"
					style={style.leoHintInfoIcon}
				/>
				{this.state.showPopup &&
					<LeoPopup
						headline={this.props.popupHeadline}
						onClose={() => this.togglePopup()}
					>
						{this.props.popupText}
					</LeoPopup>
				}
			</div>
		);
	}
}

export default radium(LeoHint);
